import React from 'react';

// Admin Imports
import MainDashboard from 'views/admin/default';

// Auth Imports
import SignIn from 'views/auth/SignIn';

// Icon Imports
import {
  MdHome,
  MdPerson,
  MdLock,
  MdShop,
  MdCardTravel,
  MdMoneyOff,
  MdMonetizationOn,
  MdContactPage,
  MdPersonAdd,
  MdPeople,
  MdEditLocation,
} from 'react-icons/md';
import Users from 'views/admin/users';
import Packages from 'views/admin/packages';
import Bookings from 'views/admin/bookings';
import WithdrawalRequests from 'views/admin/withdrawalRequests';
import UserDetails from 'views/admin/users/userDetails';
import PackageDetails from 'views/admin/packages/packageDetails';
import WithdrawalRequestDetails from 'views/admin/withdrawalRequests/withdrawalRequestDetails';
import BookingDetails from 'views/admin/bookings/Bookingdetails';
import Coupon from 'views/admin/coupons';
import ContactFormDetails from 'views/admin/contactForm/contactFormDetails';
import ContactForm from 'views/admin/contactForm';
import Profile from 'views/admin/profile';
import AdminDetails from 'views/admin/admins/adminDetails';
import Admins from 'views/admin/admins';
import CustomTrips from 'views/admin/customTrips';
import CustomTripDetails from 'views/admin/customTrips/customTripDetails';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: 'default',
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
    module: 'admin',
  },
  {
    name: 'User',
    layout: '/admin',
    path: 'user',
    icon: <MdPeople className="h-6 w-6" />,
    component: <Users />,
    module: 'User',
  },
  {
    name: 'Package',
    layout: '/admin',
    path: 'package',
    icon: <MdShop className="h-6 w-6" />,
    component: <Packages />,
    module: 'Package',
  },
  {
    name: 'Booking',
    layout: '/admin',
    path: 'booking',
    icon: <MdCardTravel className="h-6 w-6" />,
    component: <Bookings />,
    module: 'Booking',
  },
  {
    name: 'Cashout',
    layout: '/admin',
    path: 'withdrawal-request',
    icon: <MdMonetizationOn className="h-6 w-6" />,
    component: <WithdrawalRequests />,
    module: 'WithdrawalRequest',
  },

  {
    name: 'Coupon',
    layout: '/admin',
    path: 'coupon',
    icon: <MdMoneyOff className="h-6 w-6" />,
    component: <Coupon />,
    module: 'Coupon',
  },
  {
    name: 'Contact Us',
    layout: '/admin',
    path: 'contact-form',
    icon: <MdContactPage className="h-6 w-6" />,
    component: <ContactForm />,
    module: 'ContactForm',
  },
  {
    name: 'Custom Trips',
    layout: '/admin',
    path: 'custom-trips',
    icon: <MdEditLocation className="h-6 w-6" />,
    component: <CustomTrips />,
    module: 'CustomTrip',
  },
  {
    name: 'Profile ',
    layout: '/admin',
    path: 'profile-settings',
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    module: 'admin',
  },
  {
    name: 'Admin ',
    layout: '/admin',
    path: 'admins',
    icon: <MdPersonAdd className="h-6 w-6" />,
    component: <Admins />,
    module: 'Manage',
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: 'sign-in',
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];
export const detailRoutes = [
  {
    name: 'UserDetails',
    layout: '/admin',
    path: 'user/:id',
    icon: <MdPeople className="h-6 w-6" />,
    component: <UserDetails />,
    module: 'User',
  },
  {
    name: 'PackageDuplicate',
    layout: '/admin',
    path: 'package/duplicate',
    icon: <MdShop className="h-6 w-6" />,
    component: <Packages />,
    module: 'Package',
  },
  {
    name: 'PackageDetails',
    layout: '/admin',
    path: 'package/:id',
    icon: <MdPerson className="h-6 w-6" />,
    component: <PackageDetails />,
    module: 'Package',
  },

  {
    name: 'BookingDetails',
    layout: '/admin',
    path: 'booking/:id',
    icon: <MdPerson className="h-6 w-6" />,
    component: <BookingDetails />,
    module: 'Booking',
  },
  {
    name: 'WithdrawalRequestDetails',
    layout: '/admin',
    path: 'withdrawal-request/:id',
    icon: <MdPerson className="h-6 w-6" />,
    component: <WithdrawalRequestDetails />,
    module: 'WithdrawalRequest',
  },
  {
    name: 'ContactFormDetails',
    layout: '/admin',
    path: 'contact-form/:id',
    icon: <MdPerson className="h-6 w-6" />,
    component: <ContactFormDetails />,
    module: 'ContactForm',
  },
  {
    name: 'AdminsDetails',
    layout: '/admin',
    path: 'admins/:id',
    icon: <MdPerson className="h-6 w-6" />,
    component: <AdminDetails />,
    module: 'Manage',
  },
  {
    name: 'CustomTripDetails',
    layout: '/admin',
    path: 'custom-trips/:id',
    icon: <MdEditLocation className="h-6 w-6" />,
    component: <CustomTripDetails />,
    module: 'CustomTrip',
  },
];
export default routes.concat(detailRoutes);
